
import fetch from '../fetch'
const trace_url = `${window.env.api_url}/api/untp-unicloud-trace-system` 
const unique_code_url = `${window.env.api_url}/api/untp-code/untp`
const enterprise_url = `${window.env.api_url}/api/untp-enterprise/untp`
export function getSingleFactory(params) {
  return fetch({
    url: `${baseUrl}/api/v1/mes/basic/singleFactory`,
    method: 'GET',
    params
  })
}

export function getSignTypeList(factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/types/factory/${factoryId}`,
    method: 'GET'
  })
}
// 生成规则
export function getCodeRules(factoryId,type) {
  return fetch({
    url: `${trace_url}/v1/trace/code/rules/factory/${factoryId}/${type}`,
    method: 'GET'
  })
}

export function saveSignType(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/types`,
    method: 'post',
    data
  })
}

export function delSignType(id) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/types/${id}`,
    method: 'delete'
  })
}

export function getMaterialList(data, params) {
  return fetch({
    url: `${baseUrl}/api/v1/mes/basic/materialFilter/material`,
    method: 'POST',
    params,
    data
  })
}

export function createSign(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/create`,
    method: 'post',
    data
  })
}


export function getBarcodeInfo(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/info`,
    method: 'post',
    data
  })
}


export function getCodeAttrs(factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/code/attrs/factory/${factoryId}`,
    method: 'get'
  })
}
export function getRulesType() {
  return fetch({
    url: `${trace_url}/v1/trace/code/rules/type`,
    method: 'get'
  })
}

export function editCodeAttrs(data) {
  return fetch({
    url: `${trace_url}/v1/trace/code/attrs`,
    method: 'post',
    data
  })
}

export function getRuleList(factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/code/rules/factory/${factoryId}`,
    method: 'get'
  })
}
export function getRuleByCodeTypeId(params) {
  return fetch.get(`${trace_url}/v1/trace/code/rules/CodeTypes`, {params})
}
export function editCodeRule(data) {
  return fetch({
    url: `${trace_url}/v1/trace/code/rules`,
    method: 'post',
    data
  })
}
export function delCodeRule(id) {
  return fetch({
    url: `${trace_url}/v1/trace/code/rules/${id}`,
    method: 'delete'
  })
}

export function getSigns(data) {
  return fetch({
    url: `${unique_code_url}/code/codeTotal/details`,
    method: 'post',
    data
  })
}
export function getBoxCodeTrees(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/getBoxCodeTrees`,
    method: 'post',
    data
  })
}
export function getAttrByRuleType(data) {
  return fetch({
    url: `${trace_url}/v1/trace/code/attrs/factory/${data.factoryId}/${data.type}`,
    method: 'get'
  })
}
// 根据使用类型获取属性
export function getAttrsByType(data) {
  return fetch({
    url: `${trace_url}/v1/trace/code/attrs/types`,
    method: 'post',
    data
  })
}
// 企业码申请
export function uniCodeApply(data) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/addCodeApply`,
    method: 'post',
    data
  })
}
// 产品码申请
export function prodCodeApply(data) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/addProdCodeApply`,
    method: 'post',
    data
  })
}
export function getCodeApplyList(data) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/getCodeApplyRecordList`,
    method: 'post',
    data
  })
}
// 编辑申请
export function updateCodeApply(data) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/updateCodeApply`,
    method: 'post',
    data
  })
}

// 撤销申请
export function cancelCodeApply(params) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/cancelCodeApply`,
    method: 'get',
    params
  })
}
// 查询审批列表
export function getCheckList(data) {
  return fetch({
    url: `${unique_code_url}/code/codeAudit/getCodeAuditList`,
    method: 'post',
    data
  })
}
// 审批通过
export function checkPass(data) {
  return fetch({
    url: `${unique_code_url}/code/codeAudit/approvalCodeAudit`,
    method: 'post',
    data
  })
}
// 审批驳回
export function checkNo(data) {
  return fetch({
    url: `${unique_code_url}/code/codeAudit/rejectCodeAudit`,
    method: 'post',
    data
  })
}

// 申请记录下载
export function downloadCodeInfo(params) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/downloadCodeInfo`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 批量上传
export function uploadApplyFile(data) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/uploadApplyFile`,
    method: 'post',
    data
  })
}
// 模板下载
export function downloadTemplate(params) {
  return fetch({
    url: `${unique_code_url}/code/codeApply/downloadApplyTemplet`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 标识作废
// export function delCode(params) {
//   return fetch({
//     url: `${unique_code_url}/code/codeApply/downloadApplyTemplet`,
//     method: 'get',
//     params
//   })
// }

// 查询子标识
export function getCodeSons(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/sons`,
    method: 'post',
    data
  })
}

// 导入标识
export function importCode(data,factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/import/${factoryId}`,
    method: 'post',
    data
  })
}
// 标识绑定
export function bindBarcode(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/bind`,
    method: 'post',
    data
  })
}
// 批量导入绑定关系
export function bindBarcodeImport(data,factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/relation/import/${factoryId}`,
    method: 'post',
    data
  })
}
// 批量导入绑定箱关系
export function importBoxBarcodeRelation(data,factoryId) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/relation/import/importBoxBarcodeRelation/${factoryId}`,
    method: 'post',
    data
  })
}
// 解绑
export function unbindBarcode(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/unbind`,
    method: 'post',
    data
  })
}
// 标识导出
export function exportBarcode(data) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/export`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 下载标识绑定模板
export function exportRelationBarcode(params) {
  return fetch({
    url: `${trace_url}/v1/trace/barcode/export/relation`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
// 获取前n天每天生成的码的数量
export function getPastDayCodeTotal(days) {
  return fetch.get(`${unique_code_url}/code/codeTotal/getPastDayCodeCodeTotal?days=${days}`)
}

// 获取前n企业码的数量
export function getTopEnterpriseCodeTotal(num) {
  return fetch.get(`${unique_code_url}/code/codeTotal/topNCodeTotal?num=${num}`)
}

// 查询企业码状态统计
export function getEntCodeStateTotal() {
  return fetch.get(`${unique_code_url}/code/codeTotal/getEntCodeTotalReport`)
}

// 获取标识统计信息
export function getCodeTotal(params) {
  return fetch({
    url: `${unique_code_url}/code/codeTotal/getEntCodeTotal`,
    method: 'get',
    params
  })
}

// 获取登录人所在企业有关联的企业
export function getFactoryList(params) {
  return fetch({
    url: `${enterprise_url}/enterprise/rela/pageEnterpriseRoles`,
    method: 'get',
    params
  })
}

// 添加包装比例
export function savePackingRatio(params){
  return fetch.post(`${unique_code_url}/code/packing/savePackingRatio`, params)
}
//比例列表
export function pagePackingRatio(params) {
  return fetch.get(`${unique_code_url}/code/packing/pagePackingRatio`, {params})
}

// 更新比例
export function updatePackingRatio(params) {
  return fetch.put(`${unique_code_url}/code/packing/updatePackingRatio`, params)
}

// 删除比例
export function removePackingRatio(params) {
  return fetch.delete(`${unique_code_url}/code/packing/removePackingRatio`, {params})
}

//图号
export function getDrawList(params) {
  return fetch.get(`${unique_code_url}/drawing/getDrawList`, {params})
}
//rdc报表
export function rdcReport(params) {
  return fetch.post(`${unique_code_url}/foton/rdcReport`, params)
}


//码数量统计查询
export function codeStatistics(params) {
  return fetch.post(`${unique_code_url}/foton/codeStatistics`, params)
}

export function getCarveRecord(data) {
  return fetch({
    url: `${unique_code_url}/foton/carveRecord`,
    method: 'post',
    data
  })}
//生成码
export function createCodepool(params) {
    return fetch.get(`${unique_code_url}/code/codeApply/createCodepool?supplierCode=${params.supplierCode}&enterpriseCode=${params.enterpriseCode}&codeType=${params.codeType}`)
}